import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Loader from '../components/common/Loader';

const ProductAdminRoute = ({ children }) => {
  const { isAuthenticated, canManageProducts, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!canManageProducts) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProductAdminRoute;
